import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import { Card, CardContent, CardHeader, Stack, Typography } from '@mui/material';

import { useBreakpoints } from '../../hooks/useBreakpoints';

const MCard = ({ children, styleContainer, sx, title }) => {
  const theme = useTheme();
  const { isLargeMobile } = useBreakpoints();

  if (isLargeMobile) {
    return (
      <Stack sx={{ backgroundColor: theme.palette.background.paper, ...sx, ...styleContainer }}>
        {title && <Typography variant="subtitle1">{title}</Typography>}
        {[children]}
      </Stack>
    );
  }

  return (
    <Card sx={sx}>
      {title && <CardHeader title={title} />}
      <CardContent sx={styleContainer}>{[children]}</CardContent>
    </Card>
  );
};

MCard.propTypes = {
  children: PropTypes.node,
  styleContainer: PropTypes.object,
  sx: PropTypes.object,
  title: PropTypes.string
};

export default MCard;
